function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.89 7.4c-.2-.2-.2-.4-.2-.6s.1-.4.2-.6c.3-.3.8-.3 1.1 0l10 10 10-10c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-10.6 10.5c-.3.3-.8.3-1.1 0L.89 7.4z"
});

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "7bf6dbd928f743de4737dd14a2798f36.svg";
export { SvgChevronDown as ReactComponent };